import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      alignItems: 'center',
      border: '2px solid #e0e0e0',
      borderRadius: 8,
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      height: 132,
      textAlign: 'center',
      width: 114,

      '& .baseFormatIcon': {
        height: 66,
        marginBlockStart: 24,
        width: 48,
      },

      '&$selected': {
        backgroundColor: '#f8f4fe',

        '& $iconContainer': {
          backgroundColor: 'var(--x-accent-2-4)',
        },

        '& .baseFormatIcon::before': {
          borderColor: '#f8f4fe #f8f4fe transparent transparent',
        },
      },

      '&.horizontal': {
        alignItems: 'center',
        flexDirection: 'row',
        height: 74,
        justifyContent: 'start',
        paddingInline: 22,
        width: '100%',

        '& .baseFormatIcon': {
          height: 42,
          marginBlockStart: 0,
          marginInlineEnd: 16,
          width: 30,
        },

        '& $outsideText': {
          fontSize: 14,
          marginBlockStart: 0,
        },

        '& $primaryText': {
          fontSize: 9,
          lineHeight: '11px',

          '&.horizontal': {
            marginBlockEnd: 6,
          },
        },

        '& $secondaryText': {
          fontSize: 6,
          lineHeight: '9px',
        },

        '& $iconContainer': {
          width: 30,
          height: 30,
          marginBlockStart: 0,
          marginInlineEnd: 16,
        },
      },
    },
    selected: {
      borderColor: 'var(--x-accent-2-1)',

      '& $outsideText': {
        color: 'var(--x-accent-2-1)',
      },
    },

    outsideText: {
      color: 'var(--x-text-color-2)',
      fontSize: 12,
      fontWeight: 600,
      lineHeight: '16px',
      marginBlockStart: 8,
    },
    outsideTextWithIcon: {
      marginBlockStart: 16,
    },
    container: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    primaryText: {
      color: '#fff',
      fontSize: 14,
      fontWeight: 900,
      lineHeight: '17px',
    },
    secondaryText: {
      color: '#fff',
      fontSize: 9,
      lineHeight: '14px',
    },

    iconContainer: {
      backgroundColor: '#cbcbcb',
      borderRadius: 4,
      height: 48,
      marginBlockStart: 34,
      width: 48,
    },
  },
  { name: 'FramedIcon' },
);
